import React from "react";
import './input.css';

export const Input = ({ placeholder, value = "", onChange = (evt) => { }, type = "text" }) => {
    return <input className="agendamento-input" placeholder={placeholder} value={value} type={type} onChange={onChange} />
}